import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ 'attributeTitle', 'editFieldGroup', 'editField', 'editButton' ]

  toggleEditField(event) {
    this.editFieldGroupTarget.classList.remove('d-none')
    this.attributeTitleTarget.classList.add('d-none')
    this.editButtonTarget.classList.add('d-none')
  }

  saveField(event) {
    this.editFieldGroupTarget.classList.add('d-none')

    let csrfToken = $('meta[name="csrf-token"]').attr('content');
    let url = event.currentTarget.dataset.saveUrl
    let value = this.editFieldTarget.value
    let tableName = event.currentTarget.dataset.tableName
    let attributeName = event.currentTarget.dataset.attributeName

    $.ajax({
      type: 'put',
      url: url,
      data: { [tableName]: { [attributeName]: value } },
      headers: {
        'X-CSRF-Token': csrfToken
      },
      dataType: "script"
    })

    this.attributeTitleTarget.innerHTML = this.editFieldTarget.value
    this.attributeTitleTarget.classList.remove('d-none')
    this.editButtonTarget.classList.remove('d-none')
  }

  cancel() {
    this.editFieldGroupTarget.classList.add('d-none')
    this.attributeTitleTarget.classList.remove('d-none')
    this.editButtonTarget.classList.remove('d-none')
  }
}
